var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "paramc_common" } }, [
    _vm.isShelf && _vm.isShelfType == 1
      ? _c("p", [
          _c("span", { staticClass: "product_manual_margin" }, [
            _vm._v("商品サイズは固定です。サイズを確認してください。")
          ]),
          _c("br"),
          _vm._v(" "),
          _c("span", { staticClass: "product_manual_margin" }, [
            _vm._v("幅を1mm単位で入力できる商品もございます。")
          ]),
          _c("br")
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.isShelf && _vm.isShelfType == 2
      ? _c("p", [
          _c("span", { staticClass: "product_manual_margin" }, [
            _vm._v("高さ、奥行きは固定です。サイズを確認してください。")
          ]),
          _c("br")
        ])
      : _vm._e(),
    _vm._v(" "),
    _c("div", { attrs: { id: "prodcut_input_area" } }, [
      _vm.isExistReferenceImage
        ? _c(
            "div",
            { attrs: { id: "reference_image" } },
            [
              _vm.targetPlan.inputReferenceList.length > 1
                ? _c(
                    "ul",
                    { staticClass: "ul_tab small_text bold" },
                    _vm._l(_vm.targetPlan.inputReferenceList, function(
                      inputRef,
                      index
                    ) {
                      return _c(
                        "li",
                        {
                          key: "inputRef-" + index,
                          class: {
                            active: _vm.tabType == inputRef.tabId,
                            tab_title: true
                          },
                          on: {
                            click: function($event) {
                              _vm.tabType = inputRef.tabId
                            }
                          }
                        },
                        [_vm._v(_vm._s(inputRef.tabName))]
                      )
                    })
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm._l(_vm.targetPlan.inputReferenceList, function(
                inputRef,
                index
              ) {
                return _c("div", { key: "inputRefImage-" + index }, [
                  _vm.tabType == inputRef.tabId
                    ? _c("div", { staticClass: "img_field" }, [
                        _c("img", {
                          attrs: {
                            src: _vm.getImage("top/item/input/" + inputRef.img),
                            width: "100%",
                            height: "100%"
                          }
                        })
                      ])
                    : _vm._e()
                ])
              })
            ],
            2
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        {
          class: {
            product_input_size_area: _vm.isExistReferenceImage,
            product_input_size_area2: !_vm.isExistReferenceImage
          }
        },
        [
          _c("div", { staticClass: "product_input_size" }, [
            _c("div", { staticClass: "size_title" }, [_vm._v("W")]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "size_comb" },
              [
                _vm.isDisableWidth
                  ? [
                      _c("div", { staticClass: "fixed_size" }, [
                        _vm._v(_vm._s(_vm.paramForm.width))
                      ])
                    ]
                  : [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.paramForm.width,
                            expression: "paramForm.width"
                          }
                        ],
                        attrs: { type: "text" },
                        domProps: { value: _vm.paramForm.width },
                        on: {
                          keypress: _vm.validateNumber,
                          input: [
                            function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(
                                _vm.paramForm,
                                "width",
                                $event.target.value
                              )
                            },
                            function($event) {
                              _vm.paramForm.width = _vm.inputRestNumber($event)
                            }
                          ],
                          blur: _vm.onBlurStorageItemW,
                          focus: _vm.selectedAll
                        }
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "small_text" }, [
                        _vm._v(
                          _vm._s(_vm.paramForm.minWidth) +
                            "mm ～ " +
                            _vm._s(_vm.paramForm.maxWidth) +
                            "mm"
                        )
                      ])
                    ]
              ],
              2
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "product_input_size" }, [
            _c("div", { staticClass: "size_title" }, [_vm._v("H")]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "size_comb" },
              [
                _vm.isDisable
                  ? [
                      _c("input", {
                        attrs: { type: "text", disabled: _vm.isDisable },
                        on: { focus: _vm.selectedAll }
                      })
                    ]
                  : _vm.isDisableHeight
                    ? [
                        _c("div", { staticClass: "fixed_size" }, [
                          _vm._v(_vm._s(_vm.paramForm.height))
                        ])
                      ]
                    : [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.paramForm.height,
                              expression: "paramForm.height"
                            }
                          ],
                          attrs: { type: "text" },
                          domProps: { value: _vm.paramForm.height },
                          on: {
                            keypress: _vm.validateNumber,
                            input: [
                              function($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.$set(
                                  _vm.paramForm,
                                  "height",
                                  $event.target.value
                                )
                              },
                              function($event) {
                                _vm.paramForm.height = _vm.inputRestNumber(
                                  $event
                                )
                              }
                            ],
                            blur: _vm.onBlurStorageItemH,
                            focus: _vm.selectedAll
                          }
                        }),
                        _vm._v(" "),
                        _c("div", { staticClass: "small_text" }, [
                          _vm._v(
                            _vm._s(_vm.paramForm.minHeight) +
                              "mm ～ " +
                              _vm._s(_vm.paramForm.maxHeight) +
                              "mm"
                          )
                        ])
                      ]
              ],
              2
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "product_input_size" }, [
            _c("div", { staticClass: "size_title" }, [_vm._v("D")]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "size_comb" },
              [
                _vm.isDisableDepth
                  ? [
                      _c("div", { staticClass: "fixed_size" }, [
                        _vm._v(_vm._s(_vm.paramForm.depth))
                      ])
                    ]
                  : [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.paramForm.depth,
                            expression: "paramForm.depth"
                          }
                        ],
                        attrs: { type: "text" },
                        domProps: { value: _vm.paramForm.depth },
                        on: {
                          keypress: _vm.validateNumber,
                          input: [
                            function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(
                                _vm.paramForm,
                                "depth",
                                $event.target.value
                              )
                            },
                            function($event) {
                              _vm.paramForm.depth = _vm.inputRestNumber($event)
                            }
                          ],
                          blur: _vm.onBlurStorageItemD,
                          focus: _vm.selectedAll
                        }
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "small_text" }, [
                        _vm._v(
                          _vm._s(_vm.paramForm.minDepth) +
                            "mm ～ " +
                            _vm._s(_vm.paramForm.maxDepth) +
                            "mm"
                        )
                      ])
                    ]
              ],
              2
            )
          ])
        ]
      )
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "errors_field" }, [
      _vm.errors.width
        ? _c("div", { staticClass: "error_text middle_text" }, [
            _vm._v(_vm._s(_vm.errors.width))
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.errors.height
        ? _c("div", { staticClass: "error_tex middle_text" }, [
            _vm._v(_vm._s(_vm.errors.height))
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.errors.depth
        ? _c("div", { staticClass: "error_text middle_text" }, [
            _vm._v(_vm._s(_vm.errors.depth))
          ])
        : _vm._e()
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5de0521b", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5de0521b","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/main/js/payment/components/top/input/paramater/DcParamSize2.vue
// module id = null
// module chunks = 